<template>
  <div
    id="logoWrapper"
    :class="{
      'flex w-full justify-center items-center': !isMobile,
      'max-h-96 min-h-20': isMobile,
    }"
    class="-z-10 relative flex flex-grow items-center justify-center w-full"
  >
    <img
      class="logo w-full object-contain"
      :class="{ 'max-h-36': isMobile, 'max-h-48': !isMobile }"
      :src="src"
      alt="logo"
    />
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
import isMobile from '@/utils/isMobile';

@Component
export default class Logo extends Vue {
  @Prop({ type: String, required: true }) src!: string;
  private isMobile!: boolean;

  created() {
    this.isMobile = isMobile();
  }
}
</script>
<style scoped>
.logo {
  transform: translateY(var(--translateY));
  opacity: var(--opacity);
  max-width: 300px;
  height: 100%;
  padding: 12px 0;
}
</style>
